import React from 'react';
import useStyle from '../table.style';
import { UserPerfs } from '../../../../types/user/user.def';
import { CaToPay } from '../../../../types/commande/commande.def';
import { TableInfoLegendary } from 'components/molecules/Table/TableInfoLegendary';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import File from '../../../../assets/background/featureContainer/file.webp';
import { TableInfoContent } from 'components/molecules/Table/TableInfoContent';
import { userPerfstoTableMyResultData } from '../../../../helpers/table/userPerfstoTableMyResultData';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { TableMyResultCarousel } from 'components/molecules/Table/TableMyResultCarousel';

export interface TableMyResultViewProps {
  userPerfs?: UserPerfs;
  caToPay?: CaToPay;
  engagementRate?: number;
}

export interface contentsDataProps {
  legends: string[];
  me: (string | number)[];
  myClass: (string | number)[];
}

export const TableMyResultView = ({
  userPerfs,
  caToPay,
  engagementRate
}: TableMyResultViewProps) => {
  const classes = useStyle();
  const isTablet = useMediaQuery('tablet');
  const contentsData: contentsDataProps = userPerfstoTableMyResultData(
    userPerfs,
    caToPay,
    engagementRate
  );

  return (
    <FeatureContainer backgroundImage={File}>
      <div className={classes.root}>
        {isTablet ? (
          <>
            <TableMyResultCarousel
              subtitle="Mes Chiffres"
              contentsData={contentsData}
            />
          </>
        ) : (
          <>
            <TableInfoLegendary
              subTitle="Mes Chiffres"
              legends={contentsData.legends}
            />
            <div className={classes.contentBlock}>
              <TableInfoContent color="Blue" contents={contentsData.me} />
              <TableInfoContent color="White" contents={contentsData.myClass} />
            </div>
          </>
        )}
      </div>
    </FeatureContainer>
  );
};
